import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface DeleteTextBlockCriteria {
    widgetId: string;
    dashboardId: string;
}

class DeleteTextBlockCriteriaImpl implements DeleteTextBlockCriteria {
    constructor(readonly widgetId: string, readonly dashboardId: string) {}
}

export class DeleteTextBlockCriteriaBuilder {
    private widgetId: Option<string> = none;

    private dashboardId: Option<string> = none;

    static create = (): DeleteTextBlockCriteriaBuilder => new DeleteTextBlockCriteriaBuilder();

    withWidgetId = (id: string): DeleteTextBlockCriteriaBuilder => {
        this.widgetId = some(id);
        return this;
    };

    withDashboardId = (id: string): DeleteTextBlockCriteriaBuilder => {
        this.dashboardId = some(id);
        return this;
    };

    build = (): DeleteTextBlockCriteria => {
        if (isNone(this.widgetId)) {
            throw new ReferenceError('Undefined widget id');
        }

        if (isNone(this.dashboardId)) {
            throw new ReferenceError('Undefined dashboard id');
        }

        return new DeleteTextBlockCriteriaImpl(this.widgetId.value, this.dashboardId.value);
    };
}
